import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import { fetchLocalization } from "features/localization/fetchLocalization";
import { getInitLanguage } from "helpers/language";

const awsBackend = {
  type: "backend" as const,
  init: () => {},
  async read(
    language: string,
    _namespace: string,
    cb: (err: any, data: any) => void,
  ) {
    try {
      if (i18next.hasResourceBundle(language, "translation")) {
        cb(null, i18next.getResourceBundle(language, "translation"));
        return;
      }

      const data = await fetchLocalization(language);

      i18next.addResourceBundle(language, "translation", data, true, true);
      cb(null, data);
    } catch (err) {
      cb(err, null);
    }
  },
};

const INITIAL_LNG = (() => {
  try {
    const lang = getInitLanguage?.();
    return typeof lang === "string" ? lang.toLowerCase() : "en";
  } catch {
    return "en";
  }
})();

i18next
  .use(awsBackend)
  .use(initReactI18next)
  .init({
    lng: INITIAL_LNG,
    fallbackLng: false,
    ns: ["translation"],
    defaultNS: "translation",
    interpolation: { escapeValue: false },
  });

export default i18next;
